<template>  
<div> <!-- root element start -->
    <div class="container-fluid mt-2">

          <div class="row">
            <div class="col-sm-12 col-md-3">
                <div class="card border-0">
                  <div class="card-header h5 bg-transparent border-0">Options</div>
                  <div class="card-body">
                      <ul class="list-group list-group-flush">
                        <a href="#" class="list-group-item font-weight-bold" @click="changeRightView('user-list', '', '')">View User List</a>
                        <a href="#" class="list-group-item font-weight-bold" @click="changeRightView('user-quick-add', '', '')">Quick Add User</a>
                        <a href="#" class="list-group-item font-weight-bold" @click="changeRightView('invite-list', '', '')">View Invite List</a>
                        <a href="#" class="list-group-item font-weight-bold" @click="changeRightView('user-invite', '', '')">Invite User</a>
                        
                      </ul>
                  </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-9">
              <component :is="rightView" :prop1="prop1" :prop2="prop2" ></component>
            </div>
           </div>

    </div><!--  end container-fluid div -->
</div> <!-- root element end -->
</template>


<script>
import {store} from '../../stores/admin-user-store.js'


import userList from '../adminUserPageComponents/user-list.vue'
import userSingle from '../adminUserPageComponents/user-single.vue'
import userQuickAdd from '../adminUserPageComponents/user-quick-add.vue'
import userInvite from '../adminUserPageComponents/user-invite.vue'
import inviteList from '../adminUserPageComponents/invite-list.vue'
import inviteSingle from '../adminUserPageComponents/invite-single.vue'

export default {
  store,
  data: function () {
    return { 

    }
  },
  computed: {
    rightView () { return this.$store.state.rightView },
    prop1 () { return this.$store.state.prop1 },
    prop2 () { return this.$store.state.prop2 },
  },
  watch: {
    
  },
  mounted() {
    this.getUserArray();
    this.getInviteArray();
  },
  methods: {
    getUserArray() { this.$store.dispatch("getAllUsers"); },
    getInviteArray() { this.$store.dispatch("getAllInvites"); },
    changeRightView(name, prop1, prop2) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2 }); },
  },    
  components:{
    'user-list': userList,
    'user-single': userSingle,
    'user-quick-add': userQuickAdd,
    'user-invite': userInvite,
    'invite-list': inviteList,
    'invite-single': inviteSingle
  },
  filters: {

  }
}
</script>
